import React from 'react';
import PropTypes from 'prop-types';
import { CountryFlag, bemClasses } from 'project/country-flag';

const CountrySuggestion = ({ model }) => {
    if (!model) return null;

    return (
        <div className="country-suggestion">
            <CountryFlag
                childCss={'country-suggestion__flag'}
                image={model.countryFlagSrc}
                bemList={[bemClasses.M]}
            />
            <div className="country-suggestion__name">{model.country}</div>
        </div>
    );
};

CountrySuggestion.propTypes = {
    model: PropTypes.shape({
        countryFlagSrc: PropTypes.string,
        country: PropTypes.string
    })
};

export default CountrySuggestion;
